// extracted by mini-css-extract-plugin
export default {"publicGameLinkContainer":"PublicGameLink_publicGameLinkContainer__7UBQT","link":"PublicGameLink_link__4Tqzn","copyButton":"PublicGameLink_copyButton__R41S0"};